module.exports = __webpack_public_path__ + "img/ru-banner.8ccb16f.jpeg";